<template>
  <div class="col-12 text-end" v-if="visible">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div
        class="modal-content invoice"
        style="max-width: 1000px !important"
      >
        <div class="d-flex justify-content-between">
          <span>
            <b>Error Message:</b> {{ newPppoeData.PPPOE_ID ?? "N/A" }} is
            currently offline. Displaying previously saved data.</span
          >

          <span @click="$emit('close')" class="close">&times;</span>
        </div>

        <div class="hover-popup my-3">
          <div class="popup-content">
            <div class="d-flex flex-wrap justify-content-left gap-3">
              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  PPPOE ID
                </div>
                <div>
                  <h6>
                    <b>{{ newPppoeData.PPPOE_ID ?? "N/A" }}</b>
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  OLT Name
                </div>
                <div>
                  <h6>
                    <b>{{ newPppoeData.olt_connect_olt_name ?? "N/A" }}</b>
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  VLAN ID
                </div>
                <div>
                  <h6>
                    <b>{{ newPppoeData.latest_data?.vlan_id ?? "N/A" }}</b>
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  Description
                </div>
                <div>
                  <h6>
                    <b
                      >{{ newPppoeData.latest_data?.description ?? "N/A" }}</b
                    >
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  MAC Address
                </div>
                <div>
                  <h6>
                    <b
                      >{{ newPppoeData.latest_data?.mac_address ?? "N/A" }}</b
                    >
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  Port Number
                </div>
                <div>
                  <h6>
                    <b
                      >{{ newPppoeData.latest_data?.port_number ?? "N/A" }}</b
                    >
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  Last Update
                </div>
                <div>
                  <h6>
                    <b
                      >{{ newPppoeData.latest_data?.last_update ?? "N/A" }}</b
                    >
                  </h6>
                </div>
              </div>

              <div
                class="my-1 dark-modeon text-xs text-center"
                style="
                  border-radius: 0px !important;
                  flex: 1;
                  min-width: 175px;
                  max-width: 16%;
                "
              >
                <div class="py-1" style="background: rgb(2, 0, 36); color: white">
                  Distance
                </div>
                <div>
                  <h6>
                    <b>{{ newPppoeData.latest_data?.distance ?? "N/A" }}</b>
                  </h6>
                </div>
              </div>
            </div>

            <div
              class="card z-index-2 invoice-card"
              v-if="chartData && loader"
              style="height: 450px"
            >
              <div class="calendar">
                <div
                  class="calendar-item"
                  :class="selecedIndex == 'All' ? 'selected' : ''"
                >
                  <div @click="$emit('filter', 'All', 'All')">
                    <div class="calendar-day"></div>
                    <div class="calendar-date pt-2">All</div>
                  </div>
                </div>
                <div
                  class="calendar-item"
                  v-for="(data, index) in dashoardChartData"
                  :key="index"
                  :class="selecedIndex == index ? 'selected' : ''"
                >
                  <div @click="$emit('filter', data.date, index)">
                    <div class="calendar-day">{{ data.date.split(", ")[1] }}</div>
                    <div class="calendar-date">{{ data.date.split(", ")[0] }}</div>
                  </div>
                </div>
              </div>
              <GradientGraphChart
                v-if="loadernew"
                id="chart-line-two"
                title="Chart"
                description="<i class='fa fa-arrow-up text-success'></i>
              <span class='font-weight-bold'>Chart </span>"
                :chart="chartData"
              />
            </div>
            <div v-else class="card z-index-2 invoice-card" style="height: 450px">
              <Skalatonloader v-if="!loader" />
              <Skalaton class="mt-12" v-if="loader" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GradientGraphChart from "@/examples/Charts/GradientGraphChart.vue";
import Skalaton from "@/components/Skalaton.vue";
import Skalatonloader from "@/components/Skalatonloader.vue";

export default {
  name: "NewPppoePopup",
  components: {
    GradientGraphChart,
    Skalaton,
    Skalatonloader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    newPppoeData: {
      type: Object,
      default: () => ({}),
    },
    chartData: {
      type: Object,
      default: null,
    },
    loader: {
      type: Boolean,
      default: true,
    },
    loadernew: {
      type: Boolean,
      default: false,
    },
    dashoardChartData: {
      type: Array,
      default: () => [],
    },
    selecedIndex: {
      type: [String, Number],
      default: "All",
    },
  },
  emits: ["close", "filter"],
};
</script>

<style scoped>
.calendar {
  display: flex;
  justify-content: start;
  padding: 10px;
  background-color: #020024;
}
.calendar-item {
  width: 56px;
  height: 59px;
  background-color: #444;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 4px;
  font-size: 14px;
  margin-right: 24px !important;
}
.calendar-item.selected {
  background-color: #98ffcc;
  color: black;
}
.calendar-day {
  font-size: 12px;
}
.calendar-date {
  font-size: 20px;
  font-weight: bold;
}
</style>

